export default __webpack_public_path__ + "static/image-7-5945fc864553d7367a90c590cfe95d6e.jpg";